import { render, staticRenderFns } from "./imgtxt-panel.vue?vue&type=template&id=77e9807e"
import script from "./imgtxt-panel.vue?vue&type=script&lang=js"
export * from "./imgtxt-panel.vue?vue&type=script&lang=js"
import style0 from "./imgtxt-panel.vue?vue&type=style&index=0&id=77e9807e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports